<template>
  <PRadioButtonGroup
    :label="campo.label"
    style="width: 100%"
    :model-value="modelValue"
    :options="campo.opcoes"
    @update:model-value="
      (v: string | number | boolean | undefined) =>
        emit('update:modelValue', v as string)
    "
  />
</template>

<script setup lang="ts">
import { PRadioButtonGroup } from "@f360-dev/f360-prisma";
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";

defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue: string;
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
</script>
